<div
  class="custom-scroll custom-scroll--hide tw-flex tw-w-[min(50.125rem,100vw)] tw-max-w-full tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden tw-rounded-t-3xl tb:tw-rounded-3xl"
>
  <div
    #swiper
    class="swiper tw-h-[24.1875rem] tw-w-full tw-shrink-0"
  >
    <div class="swiper-wrapper tw-size-full">
      @for (item of quest.eventDescription; track $index) {
        <div class="swiper-slide tw-mt-auto tw-flex tw-w-full tw-justify-center">
          <img
            [src]="item.image | staticUrl"
            alt="Challenge background"
            class="tw-aspect-[2.07] tw-size-full tw-w-full tw-object-cover max-tb:tw-max-w-full"
          />
        </div>
      }
    </div>
    <div class="tw-absolute tw-bottom-0 tw-z-2 tw-flex tw-w-full tw-justify-center tw-p-6">
      @if (quest.eventDescription.length > 1) {
        <nav
          class="tw-flex tw-w-fit tw-items-center tw-gap-2.5 tw-rounded-3xl tw-bg-gray-700 tw-p-2"
          role="navigation"
          aria-label="Slide navigation"
        >
          <button
            class="button-prev tw-size-4 tw-rounded-full"
            (click)="toPrevSlide()"
          >
            <mat-icon
              class="!tw-size-[inherit] tw-rotate-180 tw-text-gray-100"
              [class.tw-text-gray-600]="activeSlide() === 0"
              svgIcon="arrow--design"
            />
          </button>
          @for (item of quest.eventDescription; track $index) {
            <div
              role="button"
              tabindex="0"
              class="tw-size-2 tw-rounded-full tw-bg-gray-500"
              [attr.aria-label]="'Go to slide ' + ($index + 1)"
              [class.!tw-bg-[#D9D9D9]]="activeSlide() === $index"
              (click)="toSlide($index)"
            ></div>
          }

          <button
            class="button-next tw-size-4 tw-rounded-full"
            (click)="toNextSlide()"
          >
            <mat-icon
              class="!tw-size-[inherit] tw-text-gray-100"
              [class.tw-text-gray-600]="activeSlide() === quest.eventDescription.length - 1"
              svgIcon="arrow--design"
            />
          </button>
        </nav>
      }
    </div>
  </div>
  <div
    class="tw-flex tw-w-full tw-flex-col tw-items-start tw-gap-4 tw-bg-gray-600 tw-px-8 tw-py-6 max-tb:tw-max-w-full max-tb:tw-px-4 tb:tw-h-[16.75rem] tb:tw-flex-row"
  >
    <div class="custom-scroll custom-scroll--hover -tw-mr-8 tw-flex tw-flex-col tw-gap-3 tw-pr-8 tb:tw-h-full tb:tw-overflow-auto">
      <span class="tw-text-[2.5rem] tw-font-black tw-text-yellow-400">
        {{ quest.title | translate }}
      </span>
      <div class="description-container">
        <p
          class="description-block tw-text-base tw-leading-6 tw-text-gray-200"
          [innerHTML]="quest.eventDescription[0].text | translate"
        ></p>
      </div>
    </div>

    <div
      class="tw-h-[1px] tw-w-full tw-shrink-0 tw-border-solid tw-border-gray-500 tw-bg-gray-500 tb:tw-h-full tb:tw-max-h-[199px] tb:tw-w-[1px]"
    ></div>

    <!-- Dynamic-->
    @let status = quest.status;
    @let task = quest.task;
    @let is_available = status === questStatus.AVAILABLE;
    <div class="tw-flex tw-h-full tw-w-full tw-flex-shrink-0 tw-flex-grow tw-flex-col tw-gap-4 tb:tw-w-[42.28%]">
      <div class="tw-flex tw-flex-wrap tw-gap-4 max-tb:tw-justify-between tb:tw-flex-col">
        <div class="tw-flex tw-flex-col tw-gap-1 ph:tw-w-[calc(50%-0.5rem)] tb:tw-w-full">
          <span class="tw-whitespace-nowrap tw-text-base tw-font-semibold tw-text-yellow-500">{{
            'EVENT.ICE_BREAKERS.QUEST.MODAL.QUEST' | translate
          }}</span>
          <div
            class="tw-flex tw-w-full tw-items-center tw-gap-3"
            [class.tw-cursor-pointer]="task.gameTypeId !== undefined"
            (click)="redirectToGame(task.gameTypeId)"
          >
            <p
              class="tw-my-auto tw-flex-1 tw-shrink tw-basis-0 tw-self-stretch tw-text-base tw-font-medium tw-leading-6 tw-text-gray-200"
              [innerHTML]="task.description | translate: task.params"
            ></p>
            @if (gameIcon(); as icon) {
              <div class="tw-my-auto tw-flex tw-min-h-11 tw-w-11 tw-gap-2.5 tw-self-stretch tw-overflow-hidden tw-p-0.5 max-tb:tw-hidden">
                <img
                  [src]="icon"
                  alt="Task icon"
                  class="tw-size-10 tw-flex-1 tw-shrink tw-basis-0 tw-object-contain"
                />
              </div>
            }
          </div>
        </div>
        @if (!is_available) {
          <div class="tw-flex tw-flex-col tw-gap-1 tw-text-base ph:tw-w-[calc(50%-0.5rem)] tb:tw-w-full">
            <span class="tw-whitespace-nowrap tw-font-semibold tw-text-yellow-500">{{
              'EVENT.ICE_BREAKERS.QUEST.MODAL.COMPLETE_REWARD' | translate
            }}</span>
            <span class="tw-font-medium tw-text-gray-200">
              {{ 'EVENT.ICE_BREAKERS.QUEST.MODAL.REWARD' | translate: { count: task.reward } }}
            </span>
          </div>
        }
      </div>

      @switch (status) {
        @case (questStatus.ACTIVE) {
          <app-north-pole-progress-bar
            [params]="task.params"
            [progress]="task.progress"
            (click)="redirectToGame(task.gameTypeId)"
          />
        }
        @case (questStatus.AVAILABLE) {
          <div class="tw-rounded-lg tw-bg-gray-500 tw-px-12 tw-py-3 tw-text-center tw-text-gray-400">
            {{ 'EVENT.ICE_BREAKERS.QUEST.MODAL.UNACTIVE_TO_COMPLETE' | translate }}
          </div>
        }
        @case (questStatus.REWARDED) {
          <div class="tw-rounded-lg tw-border-2 tw-border-solid tw-border-green-500 tw-py-3 tw-text-center tw-text-green-500">
            {{ 'EVENT.ICE_BREAKERS.QUEST.MODAL.COMPLETE' | translate }}
          </div>
        }
        @default {}
      }
    </div>
    <!-- -->
  </div>
</div>
